var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: { "show-footer": false, "show-title": false },
      on: { ok: _vm.confirm, cancel: _vm.close },
    },
    [
      _c("div", { staticClass: "create-plan-information" }, [
        _c("div", { staticClass: "svg-banner" }, [_c("Discount")], 1),
        _vm._v(" "),
        _c("div", { staticClass: "discount" }, [
          _vm._v("Yıllık Satın Alımlarda %30 İndirim Fırsatını Yakala"),
        ]),
        _vm._v(" "),
        _vm.planPeriod == "monthly"
          ? _c("div", { staticClass: "description" }, [
              _vm._v(
                "\n            Paket satın almak istediğinize eminmisiniz aylık alınan paketler, her ay başı ücretlendirlecektir. İptal\n            ettiğiniz günden sonra paket kullanımı bitmektedir. Bu ürünün fiyatı %20 KDV harici fiyatıdır.\n        "
              ),
            ])
          : _c("div", { staticClass: "description" }, [
              _vm._v(
                "\n            Paket satın almak istediğinize eminmisiniz aldığınız paket anlık ücrete tabidir. İptal ettiğinizde 1 yıl\n            boyunca kullanmaya devam edebilirsiniz. Bu ürünün fiyatı %20 KDV harici fiyatıdır.\n        "
              ),
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "footer" }, [
          _c(
            "div",
            { staticClass: "subbutton cancel", on: { click: _vm.close } },
            [_vm._v("İptal Et")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "subbutton", on: { click: _vm.confirm } }, [
            _vm._v("Satın Al"),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }